var urlParams = new URLSearchParams(window.location.search);
let queryString = urlParams.get('community');
if(queryString != null){
  queryString = queryString.replace(/-/g, ' ');
}
var i = setInterval(function () {
  if (typeof AD !== 'undefined') {
    clearInterval(i);
    AD.ready(function () {

      if(queryString != null && AD.is_ready){
        setTimeout(()=>{
          let a = document.getElementById("form_221_0");
          a.querySelector("option[value='" + queryString + "']").selected = true;
        }, 1200)
      }
    });
  }
}, 300);

// Function to add a title element to SVG elements with class "cog-icon" = Cognito Forms
function addTitleToCogIcons() {
  const svgElements = document.querySelectorAll('.cog-icon');

  if (svgElements.length === 0) {
    return; // No SVG elements found, exit the function
  }

  svgElements.forEach(svg => {
    // Check if the SVG element already has a title element
    if (!svg.querySelector('title')) {
      const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
      title.textContent = 'Dropdown Icon'; // Set the title text here
      svg.appendChild(title);
    }
  });
}

// Function to periodically check and add titles if needed
function checkAndAddTitles() {
  addTitleToCogIcons();
}

// Call the function when the page loads
window.addEventListener('load', checkAndAddTitles);

// Set an interval to periodically check and add titles (every 3 seconds)
setInterval(checkAndAddTitles, 3000); // 3000 milliseconds = 3 seconds